<template>
  <b-card>
    <div style="font-size: 12px">
      <div class="title">
        <span>Cadastro de Usuário</span>
      </div>
      <div class="rowContainer">
        <span> <b-icon-cloud-fill></b-icon-cloud-fill> Informações Gerais</span>
        <div class="rowContent">
          <div class="input-group">
            <input required class="input borderInput" v-model="dataUser.name" />
            <label class="user-label">
              Nome do Usuário <span class="validRed">*</span>
            </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataUser.cpf"
              v-mask="maskCpfCnpj"
              maxlength="18"
              @input="checkInputLength"
            />
            <label class="user-label">
              CPF <span class="validRed">*</span>
            </label>
          </div>

          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataUser.password"
            />
            <label class="user-label"> Senha </label>
          </div>
        </div>
      </div>
      <div class="rowContainer" style="margin-bottom: 30px">
        <div>
          <div class="btnsContainer">
            <b-button class="btnsSaveNeutral" @click="clearInputs"
              >Novo
              <b-icon-arrow-clockwise class="ml-1"></b-icon-arrow-clockwise
            ></b-button>
            <b-button class="btnsSave" @click="saveOrUpdateUser"
              >{{ dataUser.id ? "Atualizar" : "Salvar" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import CourseService from "../../services/course";

import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import { maskCurrency, maskPercentage } from "../../utils/maskMoney";
// import { ValidadeCourse } from "../../validators/course";

export default {
  props: {
    clearAll: {
      type: Boolean,
    },
  },
  data() {
    return {
      dataUser: {
        id: "",
        name: "",
        password: "",
        cpf: "",
        type: "",
      },
      getCourse: false,
      spinGeneral: false,
      maskCurrency: maskCurrency,
      isInvalidInput: "",
      maskPercentage: maskPercentage,
      selectedRadio: "",
    };
  },

  methods: {
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_USER",
    ]),
    clearInputs() {
      this.SET_DATA_SEARCH_FROM_USER({});
    },

    saveOrUpdateUser() {
      // const isNotValid = ValidadeCourse(this.dataUser);
      // if (isNotValid && Object.keys(isNotValid).length) {
      //   this.handleFocus(isNotValid.keyError);
      //   return this.$toast.open({
      //     message: isNotValid.message,
      //     type: "info",
      //   });
      // }

      if (this.dataUser.id === "") return this.saveUser();

      this.updateUser();
    },

    async saveUser() {
      try {
        if (this.dataUser.password === "") {
          return this.$toast.open({
            message: "Verifique se a senha foi preenchida",
            type: "info",
          });
        }
        const id = await CourseService.saveUsers(this.dataUser);
        this.dataUser.id = id;

        this.clearInputs();
        return this.$toast.open({
          message: "Usuário salvo com Sucesso",
          type: "success",
        });
      } catch (error) {
        console.log(error);
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      }
    },
    async updateUser() {
      try {
        if (this.dataUser.password === "") {
          return this.$toast.open({
            message: "Verifique se a senha foi preenchida",
            type: "info",
          });
        }
        await CourseService.updateUsers(this.dataUser, this.dataUser.id);

        this.clearInputs();
        this.$toast.open({
          message: "Usuário atualizado com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      }
    },

    assingEditUser() {
      Object.assign(this.dataUser, this.dataSearchUser);
      this.dataUser.cpf = this.dataSearchUser.cpf; 
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },
    checkInputLength() {
      if (this.dataUser.cpf.length === 18) this.$forceUpdate();
    },
  },
  mounted() {
    if (this.dataSearchUser.id) {
      this.assingEditUser();
    }
  },
  computed: {
    ...mapState({
      dataSearchUser: (state) => state.dataSearchUser,
    }),
    maskCpfCnpj() {
      if (this.dataUser.cpf === null) {
        return "";
      }
      if (this.dataUser.cpf.length <= 14) {
        return "###.###.###-##";
      } else {
        return "";
      }
    },
  },
  beforeDestroy() {
    this.clearInputs();
  },
};
</script>
<style scoped>
.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.content-btn-fixed {
  width: 100%;
  padding: 0.7% 0px;
  left: 60px;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #ffff;
  z-index: 10;
  box-shadow: -2px -2px 4px 0 rgba(0, 0, 0, 0.102);
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: rgb(213, 213, 213);
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: context-menu;
}

.contentImg {
  display: flex;
  width: 100%;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  padding: 20px 10px;
  margin-bottom: 10px;
  gap: 20px;
  position: relative;
}

.leftImg {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rightImg {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 80%;
  position: relative;
}

.image-container {
  width: 20%;
}

.input-container {
  width: 80%;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.input-group {
  width: 100% !important;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.contentImg > div {
  display: flex;
}

.contentImg .logo {
  height: 135px;
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 7px;
  border: solid 1px rgb(223 223 223);
  color: #aaa;
  cursor: pointer;
  margin: 0;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.logo_img_not {
  height: 148px;
  width: 200px;
  max-height: 150px;
  max-width: 200px;
  cursor: pointer;
}

#input_file {
  display: none;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.imageCourse {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 7px !important;
}

.bcsCep {
  display: flex;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}

.validRed {
  font-size: 13px;
  color: red;
}

.user-label-ob {
  position: absolute;
  left: 40px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}
.user-label-img {
  font-size: 11px;
  pointer-events: none;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  margin-top: 0.3rem;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
.input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.validRed::before {
  color: blue;
}
.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.radio-input {
  display: flex;
}

.radio-input input {
  display: none;
}

.radio-input {
  --container_width: 200px;
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  color: #707070;
  width: var(--container_width);
  overflow: hidden;
  border: 1px solid rgba(53, 52, 52, 0.226);
}

.radio-input label {
  width: 100%;
  padding: 5px 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  font-size: 11px;
  margin-bottom: 0px !important;
}

.selection {
  display: none;
  position: absolute;
  height: 100%;
  width: calc(var(--container_width) / 3);
  z-index: 0;
  left: 0;
  top: 0;
  transition: 0.15s ease;
}

.radio-input label:has(input:checked) {
  color: #fff;
}

.radio-input label:has(input:checked) ~ .selection {
  background-color: #3a4750;
  display: inline-block;
}

.radio-input label:nth-child(1):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 0 / 3));
}

.radio-input label:nth-child(2):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 1 / 3));
}

.radio-input label:nth-child(3):has(input:checked) ~ .selection {
  transform: translateX(calc(var(--container_width) * 2 / 3));
}

.selectPlusImg {
  position: relative;
  width: 23%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 8.9px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.fixedSelect3 {
  position: relative;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 40px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 20px;
  margin-right: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.title span {
  font-weight: 600;
}

.requiredFields {
  font-size: 11px;
  color: red;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}
.rowContentImg {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 40px;
}

.rowObservation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px 0 5px 0;
}

.btnsContainer {
  gap: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 2rem;
}

.btnsSave {
  border-radius: 5px;
  background-color: #0188c8;
  width: 165px;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: 165px;
  border: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

@media screen and (max-width: 700px) {
  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;
  }

  .contentImg {
    flex-direction: column;
  }

  .rightImg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    flex-direction: column;
  }

  .rowContentImg {
    display: flex;
    width: 100%;
    gap: 0px;
    flex-direction: column;
    align-items: center;
  }

  .borderInput {
    width: 100%;
  }

  .selectPlusImg {
    width: 100%;
  }

  .selectPlus {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
}
</style>
